const messages = {
  video: {
    title: 'Plongez dans l’univers de l’Art Moderne et Contemporain avec le Centre Pompidou !',
    cta: 'Voir Bande annonce'
  },
  keypoints: {
    point1: 'Une immersion dans un univers artistique et poétique',
    point2: 'Découvrez les grands principes de la création contemporaine',
    point3: 'Évoluez au sein de la plus grande collection d’Art Moderne et Contemporain d’Europe'
  },
  themes: {
    title1: 'Couleur & système',
    content1: 'Dans ce niveau scindé en deux systèmes visuels, vous devez réunir, par-delà le miroir, les couleurs en suivant un principe de symétrie.',
    title2: 'Couleur et émotion',
    content2: 'Un monde sans couleur est un monde qui n’existe pas. A vous de colorer chaque recoin de ce niveau pour en révéler la structure et reconstituer l’environnement.',
    title3: 'Lumière et physique',
    content3: 'La lumière peut devenir un marqueur physique dans l’espace. Utilisez l’empreinte lumineuse de votre avatar pour générer un passage afin d’accéder à des zones auparavant hors de portée. La lumière génère certes des ombres, mais aussi des chemins qui s’avèrent bien réels.',
    title4: 'Lumière et immersion',
    content4: 'La lumière peut faire corps avec l’espace. Jouez en oscillant à la frontière de votre empreinte lumineuse et de votre ombre. Votre déplacement dans l’espace va produire des formes inattendues, avant qu’elles ne révèlent, dans un agencement impeccable, une ombre qui s’avère être… votre propre création.',
    title5: 'Couleur et spiritualité',
    content5: 'Promenez-vous dans cet espace coloré aux formes abstraites, où chaque zone doit être activée avec l’objet et la couleur qui lui est attribuée. Essayez de les faire correspondre au-delà du symbolisme des formes et des codes couleur.',
    title6: 'Couleur et engagement',
    content6: 'Dans un univers en forme de grande métropole déshumanisée, les citadins sont une ressource qui permet de découvrir certains passages et la ville devient un grand mécanisme à manipuler.',
    title7: 'Couleur et fonction',
    content7: 'Dans une œuvre, une couleur peut avoir sa propre fonction, son propre référent. Dans ce niveau, chaque couleur renvoie à une fonctionnalité bien précise. Attribuez une couleur aux objets qui en sont dépourvus afin de progresser.'
  },
  prod: {
    text1: 'Réalisé grâce au soutien du Ministère de l\'Education Nationale et de la Jeunesse.',
    text2: 'Produit par Bright et Game in Society. En partenariat avec Ircam Amplify.',
    link: 'Lien communiqué de presse'
  },
  available: {
    date: 'Disponible maintenant'
  },
  download: {
    exe: 'Télécharger le fichier executable'
  }
}


export default messages
